/**
 * An identity provider alias travels in the `kc_idp_hint` query parameter of a
 * redirect, so anything outside this set is refused rather than forwarded to
 * Keycloak. Mirrors the server's pattern (`api/sso/discovery.py`).
 */
const IDP_ALIAS_PATTERN = /^[a-z0-9][a-z0-9._-]{0,63}$/;

export const isValidIdpAlias = (value: string): boolean =>
  IDP_ALIAS_PATTERN.test(value);
